<template>
    <div class="text-center lg:text-left" :style="{ color: footer.fontColor }">
        <a
            :href="mailLink"
            @click.prevent="goToLink(mailLink)"
            v-if="footer.email"
            class="block text-sm"
        >
            <cUtilsEdit @edit="goToCompanyField('footerEmail')">
                <span>{{ footer.email }}</span>
            </cUtilsEdit>
        </a>

        <a
            :href="phoneLink"
            @click.prevent="goToLink(phoneLink)"
            v-if="footer.tel"
            class="block text-sm"
        >
            <cUtilsEdit @edit="goToCompanyField('footerTel')">
                <span>{{ footer.tel }}</span>
            </cUtilsEdit>
        </a>

        <p v-if="showAddress" class="text-sm whitespace-pre-line">
            <cUtilsEdit @edit="goToCompanyField('footerAddress')">
                <span>{{ address }}</span>
            </cUtilsEdit>
        </p>
    </div>
</template>

<script>
import { useLegalGoTo } from "@/views/tools/legal/utils/useLegalGoTo";
import { useGoToLink } from "@/shared/utils/router/useGoToLink";
import cUtilsEdit from "@/views/shared/cUtilsEdit.vue";

export default {
    name: "cAddressCol",
    components: {
        cUtilsEdit,
    },
    setup() {
        const { goToLink } = useGoToLink();
        const { goToCompanyField } = useLegalGoTo();
        return {
            goToLink,
            goToCompanyField,
        };
    },
    props: {
        footer: Object,
    },
    computed: {
        phoneLink() {
            return `tel:${this.footer.tel}`;
        },
        mailLink() {
            return `mailto:${this.footer.email}`;
        },
        showAddress() {
            const { companyData } = this.footer;
            return (
                companyData.streetAddress ||
                companyData.streetNumber ||
                companyData.houseNumber ||
                companyData.postalCode ||
                companyData.city
            );
        },
        showCitySeparator() {
            const { companyData } = this.footer;
            return (
                (companyData.streetAddress ||
                    companyData.streetNumber ||
                    companyData.houseNumber) &&
                (companyData.postalCode || companyData.city)
            );
        },
        address() {
            const { companyData } = this.footer;
            return `${companyData.streetAddress || ""} ${companyData.streetNumber || ""}${companyData.houseNumber ? "/" : ""}${companyData.houseNumber || ""}${this.showCitySeparator ? ", " : ""}${companyData.postalCode || ""} ${companyData.city || ""}`;
        },
    },
};
</script>
